/* TWOK Sticky Mobile Nav — single clean script */
document.addEventListener('DOMContentLoaded', function () {
  var bar = document.getElementById('twok-sticky-nav');
  if (!bar) return;

  /* ========== Show/Hide helpers ========== */
  var visible = false;
  function reserveSpace(add){
    if (add){
      var h = bar.getBoundingClientRect().height + 16;
      document.body.style.paddingBottom = 'calc(' + h + 'px + env(safe-area-inset-bottom))';
    } else {
      document.body.style.paddingBottom = '';
    }
  }
  function showBar(){
    if (!visible){
      bar.classList.add('is-visible');
      reserveSpace(true);
      visible = true;
    }
  }
  function hideBar(){
    if (visible){
      bar.classList.remove('is-visible');
      document.body.style.paddingBottom = 'calc(10px + env(safe-area-inset-bottom))';
      visible = false;
    }
  }

  /* ========== Phones only ========== */
  function onResize(){
    if (window.innerWidth <= 749){
      bar.style.display = 'flex';
      showBar();
    } else {
      bar.style.display = 'none';
      reserveSpace(false);
      visible = false;
    }
  }

  /* ========== Active link (regex) ========== */
  var items = bar.querySelectorAll('.nav-icon');
  function setActive(el){
    items.forEach(i => i.classList.remove('active'));
    if (el) el.classList.add('active');
  }
  (function(){
    var path = (location.pathname || '/').replace(/\/+$/,'') || '/';
    var matched = false;
    items.forEach(function(a){
      var rx = a.getAttribute('data-match');
      if (!rx) return;
      try {
        if (new RegExp(rx).test(path)) { setActive(a); matched = true; }
      } catch(e){}
    });
    if (!matched) setActive(items[0]); // default Home
  })();

  /* ========== Trending behavior ========== */
  var trending = bar.querySelector('.js-trending');
  if (trending){
    trending.addEventListener('click', function(e){
      var target = document.querySelector('#trending-now');
      if (target && (location.pathname === '/' || location.pathname === '/index.html')){
        e.preventDefault();
        setActive(trending);
        var header = document.querySelector('.tkc-header');
        var offset = header ? header.getBoundingClientRect().height + 8 : 8;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
      // else: default link goes to /collections/best-sellers
    });
  }

  /* ========== Scroll hide/show ========== */
  var lastY = window.pageYOffset || document.documentElement.scrollTop;
  var DELTA = 8, THRESH = 80;
  function onScroll(){
    var y = window.pageYOffset || document.documentElement.scrollTop;
    if (Math.abs(y - lastY) < DELTA) return;
    if (y > lastY && y > THRESH) hideBar(); else showBar();
    lastY = y;
  }

  /* ========== Hide while keyboard open ========== */
  document.addEventListener('focusin', function(ev){
    var t = ev.target;
    if (window.innerWidth <= 749 && /(INPUT|TEXTAREA|SELECT)/.test(t.tagName)) hideBar();
  });
  document.addEventListener('focusout', function(){
    if (window.innerWidth <= 749) showBar();
  });

  /* ========== Home tap: scroll to top ========== */
  (function(){
    var home = bar.querySelector('.nav-icon[href="/"]');
    if (!home) return;
    home.addEventListener('click', function(e){
      if ((location.pathname === '/' || location.pathname === '')
          && window.scrollY > 40) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  })();

  /* ========== Cart bubble refresh after add-to-cart ========== */
  (function(){
    function refreshCartCount(){
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => document.dispatchEvent(
          new CustomEvent('cart:refresh', { detail: { count: cart.item_count } })
        ));
    }
    document.body.addEventListener('submit', function(e){
      if (e.target && e.target.matches('form[action*="/cart/add"]')) {
        setTimeout(refreshCartCount, 400);
      }
    }, true);
  })();

  document.addEventListener('cart:refresh', function(ev){
    var n = Number(ev.detail && ev.detail.count || 0);
    var link = bar.querySelector('.nav-cart');
    var b = link && link.querySelector('.count');
    if (!link) return;
    if (n > 0){
      if (!b){ b = document.createElement('b'); b.className='count'; link.appendChild(b); }
      b.textContent = n;
    } else if (b){ b.remove(); }
  }, { passive: true });

  /* ========== Init ========== */
  onResize();
  window.addEventListener('resize', onResize);
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ===== Desktop announcement marquee (single track, originals only) ===== */
  (function(){
    var bar = document.querySelector('.tkc-announcement');
    var list = bar && bar.querySelector('.tkc-announce-list');
    if (!bar || !list) return;

    function applyMarquee(){
      if (window.innerWidth < 990){
        bar.classList.remove('is-marquee');
        list.style.removeProperty('--tkc-marquee-distance');
        list.style.removeProperty('--tkc-marquee-duration');
        list.style.transform = '';
        return;
      }
      var dist = Math.max(0, list.scrollWidth - bar.clientWidth);
      if (dist > 0){
        var speed = 80; // px/second
        var duration = Math.max(12, dist / speed);
        list.style.setProperty('--tkc-marquee-distance', `-${dist}px`);
        list.style.setProperty('--tkc-marquee-duration', `${duration}s`);
        bar.classList.add('is-marquee');
      } else {
        bar.classList.remove('is-marquee');
        list.style.removeProperty('--tkc-marquee-distance');
        list.style.removeProperty('--tkc-marquee-duration');
      }
    }

    applyMarquee();
    window.addEventListener('resize', applyMarquee, { passive:true });
  })();
});
